module.exports = __webpack_public_path__ + "img/undraw_Video_streaming_re_v3qg.6ed2679f.svg";